import { reactive } from "vue";

export const routeState = reactive({
  lastRoute: null,
});
